
import { defineComponent } from "vue";
import {loadPaginatedDirectSponsor}  from "@/api/directsponsored";

export default defineComponent({
  name: "directsponsoredhistory", 
  methods: {
    async directsponsoredhistory(){ 
      this.loading = true;
      let params = {"page" : 1, "f" : this.from_date + " 00:00:00","t" : this.to_date + " 23:59:59"}
      const response = await loadPaginatedDirectSponsor(params);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
  mounted(){
      this.directsponsoredhistory();
  },
  data(){
      return { 
        list : [],
        loading: true,
        to_date :  new Date().toISOString().substr(0, 10),
        from_date: new Date().toISOString().substr(0, 10),
      }
  },
  components: {
  },
  props: {
    widgetClasses: String
  }
});

